import { render, staticRenderFns } from "./DocumentSize.vue?vue&type=template&id=5008caeb&scoped=true"
import script from "./DocumentSize.vue?vue&type=script&lang=js"
export * from "./DocumentSize.vue?vue&type=script&lang=js"
import style0 from "./DocumentSize.vue?vue&type=style&index=0&id=5008caeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008caeb",
  null
  
)

export default component.exports